(function () {
    'use strict';

    // Only loaded on the Contact page. Rendering itself is delegated to the shared
    // window.SmaoinTurnstile renderer (Smaoin.Shared.Ui's turnstile-widget.js) — this file owns only the
    // HTMX-specific glue, mirroring turnstile-signup.js's pattern for the business form.
    const CONTAINER_ID = 'cf-turnstile-container-contact';
    const INPUT_ID     = 'cf-turnstile-response-contact';
    const ACTION       = 'contact';

    const container = document.getElementById(CONTAINER_ID);
    if (!container) return;

    let tokenReady = false;

    // Cloudflare wants a tick (turnstile-tick.js): "Almost ready…" would never come true, so say what to do.
    function showTickHint(show) {
        const hint = document.getElementById('contact-tick-hint');
        if (hint) hint.hidden = !show;
    }

    const widget = window.SmaoinTurnstile.render(container, INPUT_ID, {
        action: ACTION,
        onToken: () => { tokenReady = true; showTickHint(false); },
        onExpire: () => { tokenReady = false; },
        onFail: () => { tokenReady = false; }
    });

    // An HTMX swap can re-render the hidden input empty, which means the solved token is gone and
    // the challenge has to run again. Only then, though: this fired on EVERY swap anywhere in the
    // body and reset unconditionally, so an unrelated swap threw away a perfectly good token — and
    // once the widget's own slot had been swapped, the widget id was dead and reset() threw
    // "Nothing to reset found for provided container" on every swap after it, uncaught.
    document.body.addEventListener('htmx:afterSettle', () => {
        const input = document.getElementById(INPUT_ID);
        if (!input) return;                        // this form is no longer on the page
        if (tokenReady && input.value) return;     // the token survived the swap — leave it alone

        tokenReady = false;
        widget.refresh();                          // re-mounts if the slot itself was replaced
    });

    // Inject the Turnstile token into the contact-form HTMX request,
    // or block the request and prompt the user if the challenge isn't complete yet.
    document.body.addEventListener('htmx:configRequest', e => {
        if (!(e.detail.path || '').includes('Contact')) return;

        const el = document.getElementById(INPUT_ID);
        if (el && tokenReady && el.value) {
            e.detail.parameters['cf-turnstile-response'] = el.value;
        } else {
            e.preventDefault();
            if (window.SyvTurnstileTick.showing(document.getElementById(CONTAINER_ID))) { showTickHint(true); return; }
            const btn = document.querySelector('#contact-container [type="submit"]');
            if (btn) {
                const orig = btn.textContent;
                btn.disabled = true;
                btn.textContent = 'Almost ready…';
                setTimeout(() => { btn.disabled = false; btn.textContent = orig; }, 1500);
            }
        }
    });

}());
